export default "__VITE_ASSET__75NGpIIv__"